import React, { useEffect, useState } from 'react';

import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';
import RightModal from '../../Modals/RightModal';
import InputRupees from '../../InputGroup/InputRupees';
import InputText from '../../InputGroup/InputText';
import { validityUnit } from '../../../helpers/enums';
import { insertOffer } from '../../../services/public/public.service';
import InputTextarea from '../../InputGroup/InputTextarea';
import InputSelect from '../../InputGroup/InputSelect';
import DateTimePicker from '../../InputGroup/DateTime';
import { toast } from 'react-toastify';

const OfferModal = ({ show, closeModal, style, uuid, getOffers }) => {

    const [title, setTitle] = useState('');
    const [type, setType] = useState('');
    const [amount, setAmount] = useState('');
    const [validity, setValidity] = useState('');
    const [description, setDescription] = useState('');

    const handleSubmit = async () => {
        const payload = {
            title: title,
            amount: amount,
            project_id: uuid,
            description: description,
            validity: validity,
            offer_type: type

        }
        const res = await insertOffer(payload);
        if (res.data.status === 200) {
            toast.success(res.data.message)
            getOffers();
            closeModal();
        }
    }
    return (
        <RightModal show={show} closeModal={closeModal}>

            <div className='d-flex justify-content-between border-bottom border-color px-20 py-16'>
                <h1 className='mb-0 black inter fz20 fw-po-medium'>
                    {/* {selectedBankDetail?.uuid ? 'Edit' : 'Add'} */}
                    Offers</h1>
                <button className='border-0 bg-tr ' onClick={closeModal}><CloseIcon /></button>
            </div>
            <form className={`${style.modalForm} modalForm d-flex h-100 overflow-auto flex-column px-20`}>

                <InputText
                    inputclass='!mt-0'
                    placeholder='Enter Title'
                    value={title}
                    onChange={(e) => {
                        setTitle(e.target.value)
                    }}
                    label={'Title'}
                />
                <InputText
                    inputclass='!mt-0'
                    placeholder='Enter Offer Type'
                    value={type}
                    onChange={(e) => {
                        setType(e.target.value)
                    }}
                    label={'Offer Type'}
                />
                <InputRupees
                    label="Amount"
                    placeholder="Enter Amount"
                    type="text"
                    name='amount'
                    value={amount}
                    inputclass='m-0 inter'
                    showRupees={true}
                    onChange={(value) => {
                        setAmount(value)
                    }}
                    handleBlur={() => { }}
                />
                <div>
                    <DateTimePicker
                        onValueChange={(e) => {
                            setValidity(e)
                        }}
                        label="Validity"
                        name="validity"
                        value={validity}
                        showTime={false}
                    />

                </div>
                <InputTextarea
                    label='Description'
                    placeholder='Enter Description'
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />

            </form>
            <div className={`${style.righmodalfooter} d-flex flex-row align-items-center justify-content-between border-top border-color px-20 righmodalfooter`}>
                <button className='outline-btn w-100' onClick={closeModal}>Cancel</button>
                <button type='button' onClick={handleSubmit} className='pr-btn w-100'>Submit</button>
            </div>
        </RightModal >
    )
}

export default OfferModal
